<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import emptyLayout from '@/layouts/emptyLayout.vue'
import mainLayout from '@/layouts/mainLayout.vue'

const route = useRoute()

const layout = computed(() => {
  const mainLayoutNames = ['main-layout', 'MainLayout', 'mainLayout', 'main_layout']
  const layout = route.meta?.layout ?? ''

  return mainLayoutNames.includes(layout) ? mainLayout : emptyLayout
})
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

.app {
  height: max-content;
}
</style>
